export default __webpack_public_path__ + "static/shield-surfing-3ccd9129ff8ba02f9edd30f6bc1d52c7.png";